import Vue from 'vue';
// 将金额转换成大写
function chineseNumber(dValue) {
  const fraction = ['角', '分'];
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ];
  const head = dValue < 0 ? '欠' : '';
  dValue = Math.abs(dValue);
  let s = '';
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(dValue * 10 * 10 ** i) % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  dValue = Math.floor(dValue);
  for (let i = 0; i < unit[0].length && dValue > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && dValue > 0; j++) {
      p = digit[dValue % 10] + unit[1][j] + p;
      dValue = Math.floor(dValue / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return head + s.replace(/(零.)*零元/, '元')
    .replace(/(零.)+/g, '零')
    .replace(/^整$/, '零元整');
}
function checkMoneyInputVal(dValue) {
  let maxDec = 2;
  // 验证输入金额数值或数值字符串：
  dValue = dValue.toString().replace(/,/g, '');
  dValue = dValue.replace(/^0+/, ''); // 金额数值转字符、移除逗号、移除前导零
  if (dValue === '') {
    return '零元整';
  } else if (Number.isNaN(dValue)) { // （错误：金额为空！）
    return '错误：金额不是合法的数值！';
  }

  let minus = ''; // 负数的符号“-”的大写：“负”字。可自定义字符，如“（负）”。
  if (dValue.length > 1) {
    if (dValue.indexOf('-') === 0) {
      dValue = dValue.replace('-', '');
      minus = '负';
    } // 处理负数符号“-”
    if (dValue.indexOf('+') === 0) {
      dValue = dValue.replace('+', '');
    } // 处理前导正数符号“+”（无实际意义）
  }
  // 变量定义：
  let vInt = '';
  let vDec = ''; // 字符串：金额的整数部分、小数部分
  // 金额数值转换为字符，分割整数部分和小数部分：整数、小数分开来搞（小数部分有可能四舍五入后对整数部分有进位）。
  const NoneDecLen = (typeof (maxDec) === 'undefined' || maxDec == null || Number(maxDec) < 0 || Number(maxDec) > 5); // 是否未指定有效小数位（true/false）
  const parts = dValue.split('.'); // 数组赋值：（整数部分.小数部分），Array的length=1则仅为整数。
  if (parts.length > 1) {
    [vInt, vDec] = parts;
    if (NoneDecLen) {
      maxDec = vDec.length > 5 ? 5 : vDec.length;
    } // 未指定有效小数位参数值时，自动取实际小数位长但不超5。
    let rDec = Number(`0.${ vDec }`);
    rDec *= 10 ** maxDec;
    rDec = Math.round(Math.abs(rDec));
    rDec /= 10 ** maxDec; // 小数四舍五入
    const aIntDec = rDec.toString().split('.');
    if (Number(aIntDec[0]) === 1) {
      vInt = (Number(vInt) + 1).toString();
    } // 小数部分四舍五入后有可能向整数部分的个位进位（值1）
    if (aIntDec.length > 1) {
      [, vDec] = aIntDec;
    } else {
      vDec = '';
    }
  } else {
    vInt = dValue;
    vDec = '';
    if (NoneDecLen) {
      maxDec = 0;
    }
  }
  if (vInt.length > 44) {
    return '错误：金额值太大了！整数位长【" + vInt.length.toString() + "】超过了上限——44位/千正/10^43（注：1正=1万涧=1亿亿亿亿亿，10^40）！';
  }
  return [vInt, vDec, minus];
}
function chineseNumber1(dValue) {
  let vInt = '';
  let vDec = '';
  let minus = '';
  const checkedVal = checkMoneyInputVal(dValue);
  if (typeof (checkedVal) === 'string') {
    return checkedVal;
  } else if (typeof (checkedVal) === 'object') {
    [vInt, vDec, minus] = checkedVal;
  } else {
    return '计算错误';
  }

  let resAIW; // 字符串：要输出的结果
  let zeroCount; // 零计数
  let i; let p; let
    d; // 循环因子；前一位数字；当前位数字。
  let quotient; let
    modulus; // 整数部分计算用：商数、模数
  // 准备各字符数组 Prepare the characters corresponding to the digits:
  const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']; // 零~玖
  const radices = ['', '拾', '佰', '仟']; // 拾,佰,仟
  const bigRadices = ['', '万', '亿', '兆', '京', '垓', '杼', '穰', '沟', '涧', '正']; // 万,亿,兆,京,垓,杼,穰,沟,涧,正
  const decimals = ['角', '分', '厘', '毫', '丝']; // 角/分/厘/毫/丝
  resAIW = ''; // 开始处理
  // 处理整数部分（如果有）
  if (Number(vInt) > 0) {
    zeroCount = 0;
    for (i = 0; i < vInt.length; i++) {
      p = vInt.length - i - 1;
      d = vInt.substr(i, 1);
      quotient = p / 4;
      modulus = p % 4;
      if (d === '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          resAIW += digits[0];
        }
        zeroCount = 0;
        resAIW += digits[Number(d)] + radices[modulus];
      }
      if (modulus === 0 && zeroCount < 4) {
        resAIW += bigRadices[quotient];
      }
    }
    resAIW += '元';
  }
  // 处理小数部分（如果有）
  for (i = 0; i < vDec.length; i++) {
    d = vDec.substr(i, 1);
    if (d !== '0') {
      resAIW += digits[Number(d)] + decimals[i];
    }
  }
  // 处理结果
  if (resAIW === '') {
    resAIW = '零元';
  } // 零元
  if (vDec === '') {
    resAIW += '整';
  } // ....元整
  resAIW = minus + resAIW; // 人民币/负......元角分/整
  return resAIW;
}
function chineseNumber2(dValue, parm) {
  let vInt = '';
  const checkedVal = checkMoneyInputVal(dValue);
  if (typeof (checkedVal) === 'string') {
    return checkedVal;
  } else if (typeof (checkedVal) === 'object') {
    [vInt] = checkedVal;
  } else {
    return '计算错误';
  }
  let tag = 0; let
    temp = -1;
  if (vInt.length > 0) {
    for (let i = vInt.length - 1; i >= 0; i--) {
      tag++;
      if (tag === parm) {
        temp = vInt[i];
        break;
      }
    }
  }
  return temp === -1 ? '/' : temp;
}
function chineseNumber3(dValue, pos1, pos2) {
  let vDec = '';
  const checkedVal = checkMoneyInputVal(dValue);
  if (typeof (checkedVal) === 'string') {
    return checkedVal;
  } else if (typeof (checkedVal) === 'object') {
    [, vDec] = checkedVal;
  } else {
    return '计算错误';
  }
  // var num = vDec.substr(0, 1);
  const num = vDec.substr(pos1, pos2);
  let index;
  if (num === '') {
    index = 0;
  } else {
    index = Number(num);
  }
  return index;
}
/**
 * 单个数字转为大写
 */
Vue.filter('numberToChinese', (input) => {
  const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  try {
    const result = digits[input] || input;
    return result;
  } catch (error) {
    return input;
  }
});
/**
 * 去掉中文金额
 */
Vue.filter('numberToChineseFormat', (input) => {
  if (typeof input === 'string') {
    return String(input).replace(/(.*元)整$/, '$1');
  } else {
    return input;
  }
});
/**
 * 数字
 */
Vue.filter('number', (value, num) => {
  if (!value) {
    return value;
  } else {
    return value.toFixed(num);
  }
});
/**
 * 取数值中百万位上的数值
 */
Vue.filter('moneyformatMillion', (input) => {
  if (input) {
    return chineseNumber2(input, 7);
  }
});

/**
 * 取数值中十万位上的
 */
Vue.filter('moneyformatShiwan', (input) => {
  if (input) {
    return chineseNumber2(input, 6);
  }
});
/**
 * 取数值中万位上的数值
 */
Vue.filter('moneyformatWan', (input) => {
  if (input) {
    return chineseNumber2(input, 5);
  }
});

/**
 *  取数值中千位上的数字
 */
Vue.filter('moneyformatThousand', (input) => {
  if (input) {
    return chineseNumber2(input, 4);
  }
});

/**
 * 取数值中百位上的数字
 */
Vue.filter('moneyformatHundred', (input) => {
  if (input) {
    return chineseNumber2(input, 3);
  }
});

/**
 * 取数值中十位上的数字
 */
Vue.filter('moneyformatShi', (input) => {
  if (input) {
    return chineseNumber2(input, 2);
  }
});

/**
 * 取数值中个位上的数字
 */
Vue.filter('moneyformatYuan', (input) => {
  if (input) {
    return chineseNumber2(input, 1);
  }
});
/**
 * 获取小数后的角
 */
Vue.filter('moneyformatJiao', (input) => {
  if (input) {
    return chineseNumber3(input, 0, 1);
  }
});

/**
 * 获取小数后的分
 */
Vue.filter('moneyformatFen', (input) => {
  if (input) {
    return chineseNumber3(input, 1, 2);
  }
});
// 金额大写
Vue.filter('moneyformatChinese', (value) => chineseNumber(value));
Vue.filter('moneyformat', (input) => {
  if (input) {
    return `(大写) ${ chineseNumber1(input) } （小写）${ input } 元（如大小写金额表述不一致的，以大写金额为准）`;
  }
});
/**
 * 借款金额：人民币大写
 */
Vue.filter('moneyformatChinese', (input) => {
  if (input) {
    if (typeof input !== 'string') {
      return chineseNumber1(input);
    } else {
      const tempInput = (String(input) || '').split('~');
      if (tempInput.length === 1) {
        return chineseNumber1(tempInput[0]);
      } else if (tempInput.length === 2) {
        return `${ chineseNumber1(tempInput[0]) }~${ chineseNumber1(tempInput[1]) }`;
      } else {
        return chineseNumber1(input);
      }
    }
  }
});
/**
 * 处理显示身份证位数
 */
Vue.filter('identityFilter', (value, num) => ((value || '').toString()).substr(num, 1));
Vue.filter('serviceContract', (loanContract) => {
  if (!loanContract) return loanContract;
  else return `${ loanContract }-3`;
});
Vue.filter('contract_7', (loanContract) => {
  if (!loanContract) return loanContract;
  else return `${ loanContract }-7`;
});
Vue.filter('contract_11', (loanContract) => {
  if (!loanContract) return loanContract;
  else return `${ loanContract }-11`;
});
Vue.filter('contract_1', (loanContract) => {
  if (!loanContract) return loanContract;
  else return `${ loanContract }-1`;
});
Vue.filter('guaranteeContract', (loanContract) => {
  if (!loanContract) return loanContract;
  else return `${ loanContract }-1`;
});
Vue.filter('idGender', (input) => {
  let gender = '';
  if (input) {
    gender = ((input.slice(-2, -1) % 2 === 0) ? '女' : '男');
  }
  return gender;
});
Vue.filter('custSlice', (input, start, end) => {
  if (!input) {
    return '';
  }
  return input.slice(start, end);
});

Vue.filter('birthday', (input) => {
  let birthday = '';
  if (input) {
    birthday = input.slice(-12, -4);
  }
  return birthday;
});
Vue.filter('splitStr', (input) => {
  let str = '';
  if (!input) {
    return;
  }
  const temStr = input.toString();
  if (temStr.includes('、')) {
    str = temStr.split('、').pop();
  }
  return str;
});
Vue.filter('addZero', (input) => {
  if (!input) {
    return input;
  }
  return input.toString().replace(/^(\d)$/g, '0$1');
});
